import React, { Component } from "react";
import { Row, Form, Col } from "react-bootstrap";
import debounce from "lodash-es/debounce";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import UserRequestCardList from "./components/user_request_card_list";
import { RequestFilterForm } from "./forms/request-filter.form";
import { Api } from "../utils/api";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button/Button";
import { observer } from "mobx-react";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { withStyles } from "@material-ui/core/styles";

const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit,
    borderRadius: 3,
  },
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true,
})(TablePaginationActions);

const UserRequestsListing = observer(
  class UserRequestsListing extends Component {
    constructor() {
      super();
      this.api = new Api();
      this.search = debounce(this.searchInitial.bind(this), 250, {
        leading: false,
      });
      this.onChange = this.onChange.bind(this);
      this.advancedChange = this.advancedChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
    }

    componentDidMount() {
      this.search();
    }

    searchInitial() {
      const { advancedFilter, query, searchValues } = this.props.store;
      const params = advancedFilter ? searchValues : { search: query };
      const { page } = this.props.store;

      this.api
        .get("/user_requests", { ...params, page: page + 1 })
        .then((data) => {
          console.log(data);
          return data;
        })
        .then(({ data: { user_requests: userRequests, count } }) => {
          this.props.store.setUserRequests(userRequests);
          this.props.store.setCount(count);
        });
    }

    advancedChange(query) {
      this.props.store.setSearchValues(query);
      this.search();
    }

    handleChangePage(event, page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      if (
        !event.target.value ||
        !event.target.value.length ||
        event.target.value.length > 3
      )
        this.search();
    }

    toggleAdvancedFilter() {
      this.props.store.toggleAdvancedFilter();
      this.search();
    }

    render() {
      const { userRequests } = this.props.store;
      return (
        <>
          <Row className="align-mid">
            <Col md={8}>
              <Form>
                <Form.Control
                  type="text"
                  placeholder="Procura por emissor do pedido ou idoso ou telefone (mínimo 4 caracteres)"
                  value={this.props.store.query}
                  onChange={this.onChange}
                />
              </Form>
            </Col>
            <Col md={2}>
              <Typography variant="body2">
                <Button
                  size="small"
                  color="primary"
                  onClick={this.toggleAdvancedFilter.bind(this)}
                >
                  <FontAwesomeIcon icon="filter" className="filter" />
                  Filtro Avançado
                </Button>
              </Typography>
            </Col>
          </Row>
          {this.props.store.advancedFilter && (
            <RequestFilterForm
              searchValues={this.props.store.searchValues}
              onChange={this.advancedChange}
            />
          )}
          <UserRequestCardList requests={userRequests} />
          <Grid container>
            <Grid item md={12}>
              <TablePagination
                className="pagination"
                rowsPerPageOptions={[]}
                // colSpan={3}
                count={this.props.store.count}
                rowsPerPage={10}
                page={this.props.store.page}
                onChangePage={this.handleChangePage}
                // onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </Grid>
          </Grid>
        </>
      );
    }
  }
);

export default UserRequestsListing;
